module.exports = __webpack_public_path__ + "img/home_pic_dark.c92157e0.png";